import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Case } from 'dashboard/models/case';
import { SAR } from 'dashboard/models/sar';

export interface State {
  sar: SAR | null;
  validationErrors: {
    [sarId: string]: string[];
  };
  errorMessages: {
    [sarId: string]: Record<string, string>;
  };
  cases: Case[];
}

const initialState: State = {
  sar: null,
  validationErrors: {},
  errorMessages: {},
  cases: [],
};

const { reducer, actions } = createSlice({
  name: 'sar',
  initialState,
  reducers: {
    setSAR: (state, action: PayloadAction<SAR>) => {
      state.sar = action.payload;
    },
    setSARErrorMessages: (
      state,
      action: PayloadAction<{ sarToken: string; errorMessages: Record<string, string> }>,
    ) => {
      state.errorMessages[action.payload.sarToken] = action.payload.errorMessages;
    },
    setSARValidationErrors: (
      state,
      action: PayloadAction<{ sarToken: string; validationErrors: string[] }>,
    ) => {
      state.validationErrors[action.payload.sarToken] = action.payload.validationErrors;
    },
    setSARCases: (state, action: PayloadAction<Case[]>) => {
      state.cases = castDraft(action.payload);
    },
  },
});

export const { setSAR, setSARCases, setSARValidationErrors, setSARErrorMessages } = actions;
export const SARReducer = reducer;
